import './styles.css';

import Button from '@material-ui/core/Button';
import LockOutline from '@material-ui/icons/LockOutlined';
import { WithRouter } from 'decorators/withRouter';
import { ICourse } from 'interface/course';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

interface IProps {
  auth: any;
  course: ICourse;
  match: any;
  isAuth?: boolean;
  message?: string;
  route?: string;
  textButton?: string;
}

@WithRouter()
class LoginBanner extends PureComponent<IProps> {
  render() {
    const { courseHash } = this.props.match.params;

    if ((!this.props.auth.isAuthenticated || this.props.isAuth) && this.props.course.status !== 'free') {
      return (
        <div className="login-banner-root">
          <div className="login-banner-container">
            <div className="login-banner-icon">
              <LockOutline />
            </div>
            <div className="login-banner-message">
              <label>{this.props.message || 'Já possui este curso? Acesse agora sua conta.'}</label>
            </div>
            <Link to={this.props.route || `/${courseHash ? courseHash : ''}`} className="login-banner-action">
              <Button variant="contained" color="primary">
                {this.props.textButton || 'Fazer login'}
              </Button>
            </Link>
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  auth: state.auth,
  course: state.course
});

export default connect(mapStateToProps)(LoginBanner);
